module.exports = function() {
  return new Worker(__webpack_public_path__ + "56743f0a81c47e58.worker.js");
};